const links = [
  {
    label: "Home",
    url: "/"
  },
  {
    label: "About me",
    url: "/about"
  },
  {
    label: "Projects",
    url: "/projects"
  },
  {
    label: "Contact",
    url: "/contact"
  },
]

export default links